export default __webpack_public_path__ + "static/media/refresh-white.50f5e5ae.svg";